// Unauthorized403.tsx
import { Box } from '@mui/material';
import React from 'react';

const Unauthorized403: React.FC = () => {
  return (
    <Box sx={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <h1>403 - Unauthorized</h1>
      <p>Sorry, you don't have permission to access this page.</p>
      {/* You can add additional content or links here */}
    </Box>
  );
};

export default Unauthorized403;
